import { PrizeDrawStatus } from "@/api/backofficeRest/generated/model"
import { SoChipType } from "@/types/components/SoChip"

export type DrawLifecycleDisplay = {
  label: string
  type: SoChipType
  subtitle: string
}

// Maps the fine PrizeDrawStatus lifecycle to the draw-detail status chip: a short
// label, a one-line next-step subtitle, and an accessible chip colour. Colour is
// limited to the only SoChip tonal variants that meet WCAG contrast as text on
// white — DEFAULT (grey) and ERROR (red) — matching the winners-table decision in
// OpsDrawDetailWinners.vue (success/primary/caution tonal text all fail, e.g.
// success green400 #00D9B0 ≈ 1.8:1). The label + subtitle carry the stage; ERROR
// flags the only attention state (UNKNOWN).
export const DRAW_LIFECYCLE: Record<PrizeDrawStatus, DrawLifecycleDisplay> = {
  [PrizeDrawStatus.DRAFT]: {
    label: "Draft",
    type: SoChipType.DEFAULT,
    subtitle: "Not open yet",
  },
  [PrizeDrawStatus.OPEN]: {
    label: "Open",
    type: SoChipType.DEFAULT,
    subtitle: "Accepting entries",
  },
  [PrizeDrawStatus.ENTRY_CLOSED]: {
    label: "Entry closed",
    type: SoChipType.DEFAULT,
    subtitle: "Ready to select winners",
  },
  [PrizeDrawStatus.CALCULATING_WINNERS]: {
    label: "Selecting winners",
    type: SoChipType.DEFAULT,
    subtitle: "Can take a few hours",
  },
  [PrizeDrawStatus.WINNERS_CALCULATED]: {
    label: "Winners selected",
    type: SoChipType.DEFAULT,
    subtitle: "Review the winner list",
  },
  [PrizeDrawStatus.WINNERS_NOTIFIED]: {
    label: "Winners notified",
    type: SoChipType.DEFAULT,
    subtitle: "Prizes not yet allocated",
  },
  [PrizeDrawStatus.WINNERS_PUBLISHED]: {
    label: "Winners published",
    type: SoChipType.DEFAULT,
    subtitle: "Shown on the winners page",
  },
  [PrizeDrawStatus.COMPLETED]: {
    label: "Completed",
    type: SoChipType.DEFAULT,
    subtitle: "Draw complete",
  },
  [PrizeDrawStatus.UNKNOWN]: {
    label: "Unknown",
    type: SoChipType.ERROR,
    subtitle: "Status not available",
  },
}
